import { ProductCategory } from "@utils/constants";
import { createContext } from "react";
import React from "react";

export const FilterScreenContext = createContext<{
  containerWidth: number;
  setContainerWidth: (value: number) => void;
  fromResultScreen?: boolean;
  productType?: ProductCategory;
  scrollableTabBar?: boolean;
  renderScrollableTabBar?: () => React.ReactNode;
  renderScrollableFiltersTabSection?: () => React.ReactNode;
}>({
  containerWidth: 0,
  setContainerWidth: () => {},
  productType: ProductCategory.DIAMOND,
  scrollableTabBar: false,
  renderScrollableTabBar: undefined,
  renderScrollableFiltersTabSection: undefined,
});
